import React, { useEffect } from 'react';
import * as Bento from '@prezi/bento';
import { ColumnAutoMin } from '../../atoms/dumb';
const ToggleSimple = ({
  checked,
  label,
  disabled,
  id,
  handleOnChange,
  triggerRef,
  setTooltipOpen,
  dataLookup
}) => {
  const [isChecked, setChecked] = React.useState(checked);
  useEffect(() => {
    setChecked(checked);
  }, [checked]);
  return React.createElement(ColumnAutoMin, null, React.createElement(Bento.Body2, null, label), React.createElement("div", {
    ref: triggerRef,
    onMouseEnter: () => setTooltipOpen && setTooltipOpen(true),
    onMouseLeave: () => setTooltipOpen && setTooltipOpen(false)
  }, React.createElement(Bento.Switch, {
    disabled: disabled,
    checked: isChecked,
    name: id,
    id: id,
    onChange: ev => {
      setChecked(!isChecked);
      handleOnChange(ev.currentTarget.checked);
    },
    onEnterKeyPress: () => {
      setChecked(!isChecked);
      handleOnChange(!isChecked);
    },
    "data-lookup": dataLookup
  })));
};
export default ToggleSimple;